export const validateEnv = () => {
  const missingVars = [];
  if (!process.env.REACT_APP_API_URL) missingVars.push("REACT_APP_API_URL");
  if (!process.env.REACT_APP_INTERCOM_APP_ID)
    missingVars.push("REACT_APP_INTERCOM_APP_ID");
  if (!process.env.REACT_APP_SITE_URL) missingVars.push("REACT_APP_SITE_URL");

  return missingVars;
};
